import { Injectable } from '@angular/core';
import { Messaging, getToken, onMessage } from '@angular/fire/messaging';
import { Observable, Subject } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable({
    providedIn: 'root'
})
export class FirebaseMessagingService {
    private _messageSubject = new Subject<any>();
    public message$ = this._messageSubject.asObservable();
    private currentToken: string | null = null;

    constructor(private messaging: Messaging) {
        this.listenForMessages();
    }

    async requestPermissionAndGetToken(): Promise<string | null> {
        try {
            const permission = await Notification.requestPermission();

            if (permission === 'granted') {
                console.log('Notification permission granted.');

                const token = await getToken(this.messaging);

                if (token) {
                    console.log('FCM Token:', token);
                    this.currentToken = token;
                    return token;
                } else {
                    console.log('No registration token available.');
                    return null;
                }
            } else {
                console.log('Unable to get permission to notify.');
                return null;
            }
        } catch (error) {
            console.error('An error occurred while retrieving token:', error);
            return null;
        }
    }

    private listenForMessages(): void {
        onMessage(this.messaging, (payload) => {
            console.log('Message received in foreground:', payload);
            this._messageSubject.next(payload);
        });
    }

    getCurrentToken(): string | null {
        return this.currentToken;
    }
}
